import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles(() => ({
  Secondary: {
    display: "flex",
    backgroundColor: "#f9f9f9",
    flexDirection: "column",
    height: "100%",
    minHeight: "100%",
    justifyContent: "space-between",
    width: "100%"
  },
  Box: {
    marginTop: "10px"
  },

  topOption: {
    borderBottom: "2px solid #A4A4A4"
  },

  topSelected: {
    display: "flex",
    justifyContent: "center",
    fontSize: "1em",
    color: "#EA3458",
    fontWeight: "bold",
    borderBottom: "4px solid #EA3458",
    width: "25%"
  },

  topSelector: {
    display: "flex",
    fontSize: "0.875em",
    color: "#A4A4A4",
    fontWeight: "bold",
    flexDirection: "column",
    alignItems: "center",
    marginRight: "1em"
  },

  topSelector2: {
    display: "flex",
    fontSize: "0.875em",
    color: "#A4A4A4",
    fontWeight: "bold",
    justifyContent: "space-between"
  },

  cardPie: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.05)",
    margin: "1em",
    backgroundColor: "#fff",
    alignItems: "center",
    border: "1px solid #F3F3F3",
    borderRadius: "5px",
    justifyContent: "space-around"
  },

  teste: {
    display: "flex"
  },

  teste2: {
    display: "flex"
  },

  cardSubtitle: {
    width: "12px",
    height: "12px",
    borderRadius: "2px"
  },

  bannerSejaPro: {
    flexbox: "flex",
    height: "200px",
    borderRadius: "5px",
    fontSize: "24px",
    fontWeight: "400",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#C4C4C4",
    marginTop: "40px",
    marginLeft: "20px",
    marginRight: "20px",
    marginBottom: "20px"
  },

  /// //////////////////////////////////////////////

  btnAddLogo: {
    color: "#fff",
    minWidth: "100%",
    height: "50px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    marginTop: "5px",
    marginBottom: "15px",
    textTransform: "none",
    backgroundColor: "#EA3458",

    "& .MuiButton-label": {
      textTransform: "capitalize",
      fontSize: "14px",
      fontWeight: "500"
    },

    "&:hover": {
      backgroundColor: "#ff5089c9"
    }
  }
}))
